// src/components/VideoPlayer.jsx
import React from 'react';

export default function VideoPlayer({ url, className = "" }) {
  const finalClass = `w-full aspect-video rounded-xl ${className}`;

  // Detect if it's a YouTube link
  const isYouTube = url && (
    url.includes('youtube.com/embed') ||
    url.includes('youtu.be') ||
    url.includes('youtube.com/watch')
  );

  if (isYouTube) {
    // Extract video ID if needed and build clean embed URL
    let videoId = url;
    if (url.includes('youtube.com/watch?v=')) {
      videoId = url.split('v=')[1]?.split('&')[0];
    } else if (url.includes('youtu.be/')) {
      videoId = url.split('youtu.be/')[1]?.split('?')[0];
    } else if (url.includes('youtube.com/embed/')) {
      videoId = url.split('embed/')[1]?.split('?')[0];
    }

    return (
      <iframe
        src={`https://www.youtube.com/embed/${videoId}?autoplay=1&modestbranding=1&rel=0&playsinline=1`}
        className={finalClass}
        allowFullScreen
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        title="Service Video"
        loading="lazy"
      />
    );
  }

  // Fallback for direct MP4 videos
  return (
    <video
      controls
      className={finalClass}
      preload="metadata"
      title="Service Video"
    >
      <source src={url} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
}
